import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const POLL_MS = 30000;

export default function NotificationBell() {
  const [count, setCount] = useState(0);
  const navigate = useNavigate();

  async function load() {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/notifications?unreadOnly=true`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const rows = await res.json();
      setCount(Array.isArray(rows) ? rows.length : 0);
    } catch {
      setCount(0);
    }
  }

  useEffect(() => {
    load();
    const t = setInterval(load, POLL_MS);
    return () => clearInterval(t);
  }, []);

  return (
    <button
      aria-label="Notifications"
      onClick={() => navigate('/inbox')}
      style={{ position:'relative', background:'none', border:'none', cursor:'pointer' }}
      title="Open Inbox"
    >
      🔔
      {count > 0 && (
        <span style={{
          position:'absolute', top:-6, right:-6, minWidth:18, height:18, borderRadius:9,
          fontSize:12, lineHeight:'18px', textAlign:'center', background:'#e11', color:'#fff', padding:'0 4px'
        }}>{count}</span>
      )}
    </button>
  );
}
